import React from 'react';

import styles from './Overlay.scss';

/**  Overlay is using absolute postion. Remember to set posiiton Reletive on the parent element */

interface Props {
  isActive: boolean;
}

const Overlay: React.FC<Props> = ({ isActive }) =>
  isActive ? <div data-testid="promotion-overlay" className={styles.overlay} /> : null;

export { Overlay };
